export const nations = [
  {
    value: 'ABW',
    label: 'Aruba',
  },
  {
    value: 'AFG',
    label: 'Afghanistan',
  },
  {
    value: 'AGO',
    label: 'Angola',
  },
  {
    value: 'AIA',
    label: 'Anguilla',
  },
  {
    value: 'ALB',
    label: 'Albania',
  },
  {
    value: 'AND',
    label: 'Andorra',
  },
  {
    value: 'ANT',
    label: 'Antille Olandesi',
  },
  {
    value: 'ARE',
    label: 'Emirati Arabi Uniti',
  },
  {
    value: 'ARG',
    label: 'Argentina',
  },
  {
    value: 'ARM',
    label: 'Armenia',
  },
  {
    value: 'ASM',
    label: 'Samoa Americane',
  },
  {
    value: 'ATA',
    label: 'Antartide',
  },
  {
    value: 'ATF',
    label: 'Territori Francesi del Sud',
  },
  {
    value: 'ATG',
    label: 'Antigua e Barbuda',
  },
  {
    value: 'AUS',
    label: 'Australia',
  },
  {
    value: 'AUT',
    label: 'Austria',
  },
  {
    value: 'AZE',
    label: 'Azerbaijan',
  },
  {
    value: 'BDI',
    label: 'Burundi',
  },
  {
    value: 'BEL',
    label: 'Belgio',
  },
  {
    value: 'BEN',
    label: 'Benin',
  },
  {
    value: 'BFA',
    label: 'Burkina Faso',
  },
  {
    value: 'BGD',
    label: 'Bangladesh',
  },
  {
    value: 'BGR',
    label: 'Bulgaria',
  },
  {
    value: 'BHR',
    label: 'Bahrain',
  },
  {
    value: 'BHS',
    label: 'Bahamas',
  },
  {
    value: 'BIH',
    label: 'Bosnia Erzegovina',
  },
  {
    value: 'BLM',
    label: 'Saint Barthélemy',
  },
  {
    value: 'BLR',
    label: 'Bielorussia',
  },
  {
    value: 'BLZ',
    label: 'Belize',
  },
  {
    value: 'BMU',
    label: 'Bermuda',
  },
  {
    value: 'BOL',
    label: 'Bolivia',
  },
  {
    value: 'BRA',
    label: 'Brasile',
  },
  {
    value: 'BRB',
    label: 'Barbados',
  },
  {
    value: 'BRN',
    label: 'Brunei Darussalam',
  },
  {
    value: 'BTN',
    label: 'Bhutan',
  },
  {
    value: 'BVT',
    label: 'Isola di Bouvet',
  },
  {
    value: 'BWA',
    label: 'Botswana',
  },
  {
    value: 'CAF',
    label: 'Repubblica Centroafricana',
  },
  {
    value: 'CAN',
    label: 'Canada',
  },
  {
    value: 'CCK',
    label: 'Isole Cocos',
  },
  {
    value: 'CHE',
    label: 'Svizzera',
  },
  {
    value: 'CHL',
    label: 'Cile',
  },
  {
    value: 'CHN',
    label: 'Cina',
  },
  {
    value: 'CIV',
    label: 'Costa dAvorio',
  },
  {
    value: 'CMR',
    label: 'Camerun',
  },
  {
    value: 'COD',
    label: 'Repubblica Democratica del Congo',
  },
  {
    value: 'COG',
    label: 'Repubblica del Congo',
  },
  {
    value: 'COK',
    label: 'Isole Cook',
  },
  {
    value: 'COL',
    label: 'Colombia',
  },
  {
    value: 'COM',
    label: 'Comore',
  },
  {
    value: 'CPV',
    label: 'Capo Verde',
  },
  {
    value: 'CRI',
    label: 'Costa Rica',
  },
  {
    value: 'CUB',
    label: 'Cuba',
  },
  {
    value: 'CXR',
    label: 'Isola di Natale',
  },
  {
    value: 'CYM',
    label: 'Isole Cayman',
  },
  {
    value: 'CYP',
    label: 'Cipro',
  },
  {
    value: 'CZE',
    label: 'Repubblica Ceca',
  },
  {
    value: 'DEU',
    label: 'Germania',
  },
  {
    value: 'DJI',
    label: 'Gibuti',
  },
  {
    value: 'DMA',
    label: 'Dominica',
  },
  {
    value: 'DNK',
    label: 'Danimarca',
  },
  {
    value: 'DOM',
    label: 'Repubblica Dominicana',
  },
  {
    value: 'DZA',
    label: 'Algeria',
  },
  {
    value: 'ECU',
    label: 'Ecuador',
  },
  {
    value: 'EGY',
    label: 'Egitto',
  },
  {
    value: 'ERI',
    label: 'Eritrea',
  },
  {
    value: 'ESH',
    label: 'Sahara Occidentale',
  },
  {
    value: 'ESP',
    label: 'Spagna',
  },
  {
    value: 'EST',
    label: 'Estonia',
  },
  {
    value: 'ETH',
    label: 'Etiopia',
  },
  {
    value: 'FIN',
    label: 'Finlandia',
  },
  {
    value: 'FJI',
    label: 'Fiji',
  },
  {
    value: 'FLK',
    label: 'Isole Falkland',
  },
  {
    value: 'FRA',
    label: 'Francia',
  },
  {
    value: 'FRO',
    label: 'Isole Faroe',
  },
  {
    value: 'FSM',
    label: 'Stati Federati della Micronesia',
  },
  {
    value: 'GAB',
    label: 'Gabon',
  },
  {
    value: 'GBR',
    label: 'Regno Unito',
  },
  {
    value: 'GEO',
    label: 'Georgia',
  },
  {
    value: 'GGY',
    label: 'Guernsey',
  },
  {
    value: 'GHA',
    label: 'Ghana',
  },
  {
    value: 'GIB',
    label: 'Gibilterra',
  },
  {
    value: 'GIN',
    label: 'Guinea',
  },
  {
    value: 'GLP',
    label: 'Guadalupa',
  },
  {
    value: 'GMB',
    label: 'Gambia',
  },
  {
    value: 'GNB',
    label: 'Guinea-Bissau',
  },
  {
    value: 'GNQ',
    label: 'Guinea Equatoriale',
  },
  {
    value: 'GRC',
    label: 'Grecia',
  },
  {
    value: 'GRD',
    label: 'Grenada',
  },
  {
    value: 'GRL',
    label: 'Groenlandia',
  },
  {
    value: 'GTM',
    label: 'Guatemala',
  },
  {
    value: 'GUF',
    label: 'Guyana Francese',
  },
  {
    value: 'GUM',
    label: 'Guam',
  },
  {
    value: 'GUY',
    label: 'Guyana',
  },
  {
    value: 'HKG',
    label: 'Hong Kong',
  },
  {
    value: 'HMD',
    label: 'Isola Heard e Isole McDonald',
  },
  {
    value: 'HND',
    label: 'Honduras',
  },
  {
    value: 'HRV',
    label: 'Croazia',
  },
  {
    value: 'HTI',
    label: 'Haiti',
  },
  {
    value: 'HUN',
    label: 'Ungheria',
  },
  {
    value: 'IDN',
    label: 'Indonesia',
  },
  {
    value: 'IND',
    label: 'India',
  },
  {
    value: 'IOT',
    label: "Territori Britannici dell'Oceano Indiano",
  },
  {
    value: 'IRL',
    label: 'Eire',
  },
  {
    value: 'IRN',
    label: 'Iran',
  },
  {
    value: 'IRQ',
    label: 'Iraq',
  },
  {
    value: 'ISL',
    label: 'Islanda',
  },
  {
    value: 'ISR',
    label: 'Israele',
  },
  {
    value: 'ITA',
    label: 'Italia',
  },
  {
    value: 'JAM',
    label: 'Giamaica',
  },
  {
    value: 'JOR',
    label: 'Giordania',
  },
  {
    value: 'JPN',
    label: 'Giappone',
  },
  {
    value: 'KAZ',
    label: 'Kazakhistan',
  },
  {
    value: 'KEN',
    label: 'Kenya',
  },
  {
    value: 'KGZ',
    label: 'Kirghizistan',
  },
  {
    value: 'KHM',
    label: 'Cambogia',
  },
  {
    value: 'KIR',
    label: 'Kiribati',
  },
  {
    value: 'KNA',
    label: 'Saint Kitts e Nevis',
  },
  {
    value: 'KOR',
    label: 'Corea del Sud',
  },
  {
    value: 'KWT',
    label: 'Kuwait',
  },
  {
    value: 'LAO',
    label: 'Laos',
  },
  {
    value: 'LBN',
    label: 'Libano',
  },
  {
    value: 'LBR',
    label: 'Liberia',
  },
  {
    value: 'LBY',
    label: 'Libia',
  },
  {
    value: 'LCA',
    label: 'Santa Lucia',
  },
  {
    value: 'LIE',
    label: 'Liechtenstein',
  },
  {
    value: 'LKA',
    label: 'Sri Lanka',
  },
  {
    value: 'LSO',
    label: 'Lesotho',
  },
  {
    value: 'LTU',
    label: 'Lituania',
  },
  {
    value: 'LUX',
    label: 'Lussemburgo',
  },
  {
    value: 'LVA',
    label: 'Lettonia',
  },
  {
    value: 'MAC',
    label: 'Macao',
  },
  {
    value: 'MAR',
    label: 'Marocco',
  },
  {
    value: 'MCO',
    label: 'Monaco',
  },
  {
    value: 'MDA',
    label: 'Moldavia',
  },
  {
    value: 'MDG',
    label: 'Madagascar',
  },
  {
    value: 'MDV',
    label: 'Maldive',
  },
  {
    value: 'MEX',
    label: 'Messico',
  },
  {
    value: 'MHL',
    label: 'Isole Marshall',
  },
  {
    value: 'MKD',
    label: 'Macedonia',
  },
  {
    value: 'MLI',
    label: 'Mali',
  },
  {
    value: 'MLT',
    label: 'Malta',
  },
  {
    value: 'MMR',
    label: 'Myanmar',
  },
  {
    value: 'MNE',
    label: 'Montenegro',
  },
  {
    value: 'MNG',
    label: 'Mongolia',
  },
  {
    value: 'MNP',
    label: 'Isole Marianne Settentrionali',
  },
  {
    value: 'MOZ',
    label: 'Mozambico',
  },
  {
    value: 'MRT',
    label: 'Mauritania',
  },
  {
    value: 'MSR',
    label: 'Montserrat',
  },
  {
    value: 'MTQ',
    label: 'Martinica',
  },
  {
    value: 'MUS',
    label: 'Maurizius',
  },
  {
    value: 'MWI',
    label: 'Malawi',
  },
  {
    value: 'MYS',
    label: 'Malesia',
  },
  {
    value: 'MYT',
    label: 'Mayotte',
  },
  {
    value: 'NAM',
    label: 'Namibia',
  },
  {
    value: 'NCL',
    label: 'Nuova Caledonia',
  },
  {
    value: 'NER',
    label: 'Niger',
  },
  {
    value: 'NFK',
    label: 'Isola Norfolk',
  },
  {
    value: 'NGA',
    label: 'Nigeria',
  },
  {
    value: 'NIC',
    label: 'Nicaragua',
  },
  {
    value: 'NIU',
    label: 'Niue',
  },
  {
    value: 'NLD',
    label: 'Paesi Bassi',
  },
  {
    value: 'NOR',
    label: 'Norvegia',
  },
  {
    value: 'NPL',
    label: 'Nepal',
  },
  {
    value: 'NRU',
    label: 'Nauru',
  },
  {
    value: 'NZL',
    label: 'Nuova Zelanda',
  },
  {
    value: 'OMN',
    label: 'Oman',
  },
  {
    value: 'PAK',
    label: 'Pakistan',
  },
  {
    value: 'PAN',
    label: 'Panama',
  },
  {
    value: 'PCN',
    label: 'Pitcairn',
  },
  {
    value: 'PER',
    label: 'Peru',
  },
  {
    value: 'PHL',
    label: 'Filippine',
  },
  {
    value: 'PLW',
    label: 'Palau',
  },
  {
    value: 'PNG',
    label: 'Papua Nuova Guinea',
  },
  {
    value: 'POL',
    label: 'Polonia',
  },
  {
    value: 'PRI',
    label: 'Porto Rico',
  },
  {
    value: 'PRK',
    label: 'Corea del Nord',
  },
  {
    value: 'PRT',
    label: 'Portogallo',
  },
  {
    value: 'PRY',
    label: 'Paraguay',
  },
  {
    value: 'PSE',
    label: 'Territori Palestinesi Occupati',
  },
  {
    value: 'PYF',
    label: 'Polinesia Francese',
  },
  {
    value: 'QAT',
    label: 'Qatar',
  },
  {
    value: 'REU',
    label: 'Reunion',
  },
  {
    value: 'ROU',
    label: 'Romania',
  },
  {
    value: 'RUS',
    label: 'Federazione Russa',
  },
  {
    value: 'RWA',
    label: 'Ruanda',
  },
  {
    value: 'SAU',
    label: 'Arabia Saudita',
  },
  {
    value: 'SDN',
    label: 'Sudan',
  },
  {
    value: 'SEN',
    label: 'Senegal',
  },
  {
    value: 'SGP',
    label: 'Singapore',
  },
  {
    value: 'SGS',
    label: 'Sud Georgia e Isole Sandwich',
  },
  {
    value: 'SHN',
    label: "Sant'Elena",
  },
  {
    value: 'SJM',
    label: 'Svalbard e Jan Mayen',
  },
  {
    value: 'SLB',
    label: 'Isole Solomon',
  },
  {
    value: 'SLE',
    label: 'Sierra Leone',
  },
  {
    value: 'SLV',
    label: 'El Salvador',
  },
  {
    value: 'SMR',
    label: 'San Marino',
  },
  {
    value: 'SOM',
    label: 'Somalia',
  },
  {
    value: 'SPM',
    label: 'Saint Pierre e Miquelon',
  },
  {
    value: 'SRB',
    label: 'Serbia',
  },
  {
    value: 'STP',
    label: 'Sao Tome e Principe',
  },
  {
    value: 'SUR',
    label: 'Suriname',
  },
  {
    value: 'SVK',
    label: 'Slovacchia',
  },
  {
    value: 'SVN',
    label: 'Slovenia',
  },
  {
    value: 'SWE',
    label: 'Svezia',
  },
  {
    value: 'SWZ',
    label: 'Swaziland',
  },
  {
    value: 'SYC',
    label: 'Seychelles',
  },
  {
    value: 'SYR',
    label: 'Siria',
  },
  {
    value: 'TCA',
    label: 'Isole Turks e Caicos',
  },
  {
    value: 'TCD',
    label: 'Ciad',
  },
  {
    value: 'TGO',
    label: 'Togo',
  },
  {
    value: 'THA',
    label: 'Tailandia',
  },
  {
    value: 'TJK',
    label: 'Tagikistan',
  },
  {
    value: 'TKL',
    label: 'Tokelau',
  },
  {
    value: 'TKM',
    label: 'Turkmenistan',
  },
  {
    value: 'TLS',
    label: 'Timor Est',
  },
  {
    value: 'TON',
    label: 'Tonga',
  },
  {
    value: 'TTO',
    label: 'Trinidad e Tobago',
  },
  {
    value: 'TUN',
    label: 'Tunisia',
  },
  {
    value: 'TUR',
    label: 'Turchia',
  },
  {
    value: 'TUV',
    label: 'Tuvalu',
  },
  {
    value: 'TWN',
    label: 'Taiwan',
  },
  {
    value: 'TZA',
    label: 'Tanzania',
  },
  {
    value: 'UGA',
    label: 'Uganda',
  },
  {
    value: 'UKR',
    label: 'Ucraina',
  },
  {
    value: 'UMI',
    label: "Isole Minori degli Stati Uniti d'America",
  },
  {
    value: 'URY',
    label: 'Uruguay',
  },
  {
    value: 'USA',
    label: "Stati Uniti d'America",
  },
  {
    value: 'UZB',
    label: 'Uzbekistan',
  },
  {
    value: 'VAT',
    label: 'Citta del Vaticano',
  },
  {
    value: 'VCT',
    label: 'Saint Vincent e Grenadine',
  },
  {
    value: 'VEN',
    label: 'Venezuela',
  },
  {
    value: 'VGB',
    label: 'Isole Vergini Britanniche',
  },
  {
    value: 'VIR',
    label: 'Isole Vergini Americane',
  },
  {
    value: 'VNM',
    label: 'Vietnam',
  },
  {
    value: 'VUT',
    label: 'Vanuatu',
  },
  {
    value: 'WLF',
    label: 'Wallis e Futuna',
  },
  {
    value: 'WSM',
    label: 'Samoa',
  },
  {
    value: 'XKX',
    label: 'Kosovo',
  },
  {
    value: 'YEM',
    label: 'Yemen',
  },
  {
    value: 'ZAF',
    label: 'Sud Africa',
  },
  {
    value: 'ZMB',
    label: 'Zambia',
  },
  {
    value: 'ZWE',
    label: 'Zimbabwe',
  },
];

export const districts = [
  { value: 'AG', label: 'Agrigento' },
  { value: 'AL', label: 'Alessandria' },
  { value: 'AN', label: 'Ancona' },
  { value: 'AO', label: 'Aosta' },
  { value: 'AR', label: 'Arezzo' },
  { value: 'AP', label: 'Ascoli-Piceno' },
  { value: 'AT', label: 'Asti' },
  { value: 'AV', label: 'Avellino' },
  { value: 'BA', label: 'Bari' },
  { value: 'BT', label: 'Barletta-Andria-Trani' },
  { value: 'BL', label: 'Belluno' },
  { value: 'BN', label: 'Benevento' },
  { value: 'BG', label: 'Bergamo' },
  { value: 'BI', label: 'Biella' },
  { value: 'BO', label: 'Bologna' },
  { value: 'BZ', label: 'Bolzano' },
  { value: 'BS', label: 'Brescia' },
  { value: 'BR', label: 'Brindisi' },
  { value: 'CA', label: 'Cagliari' },
  { value: 'CL', label: 'Caltanissetta' },
  { value: 'CB', label: 'Campobasso' },
  { value: 'CI', label: 'Carbonia Iglesias' },
  { value: 'CE', label: 'Caserta' },
  { value: 'CT', label: 'Catania' },
  { value: 'CZ', label: 'Catanzaro' },
  { value: 'CH', label: 'Chieti' },
  { value: 'CO', label: 'Como' },
  { value: 'CS', label: 'Cosenza' },
  { value: 'CR', label: 'Cremona' },
  { value: 'KR', label: 'Crotone' },
  { value: 'CN', label: 'Cuneo' },
  { value: 'EN', label: 'Enna' },
  { value: 'FM', label: 'Fermo' },
  { value: 'FE', label: 'Ferrara' },
  { value: 'FI', label: 'Firenze' },
  { value: 'FG', label: 'Foggia' },
  { value: 'FC', label: 'Forli-Cesena' },
  { value: 'FR', label: 'Frosinone' },
  { value: 'GE', label: 'Genova' },
  { value: 'GO', label: 'Gorizia' },
  { value: 'GR', label: 'Grosseto' },
  { value: 'IM', label: 'Imperia' },
  { value: 'IS', label: 'Isernia' },
  { value: 'AQ', label: `L'Aquila` },
  { value: 'SP', label: 'La Spezia' },
  { value: 'LT', label: 'Latina' },
  { value: 'LE', label: 'Lecce' },
  { value: 'LC', label: 'Lecco' },
  { value: 'LI', label: 'Livorno' },
  { value: 'LO', label: 'Lodi' },
  { value: 'LU', label: 'Lucca' },
  { value: 'MC', label: 'Macerata' },
  { value: 'MN', label: 'Mantova' },
  { value: 'MS', label: 'Massa-Carrara' },
  { value: 'MT', label: 'Matera' },
  { value: 'VS', label: 'Medio Campidano' },
  { value: 'ME', label: 'Messina' },
  { value: 'MI', label: 'Milano' },
  { value: 'MO', label: 'Modena' },
  { value: 'MB', label: 'Monza-Brianza' },
  { value: 'NA', label: 'Napoli' },
  { value: 'NO', label: 'Novara' },
  { value: 'NU', label: 'Nuoro' },
  { value: 'OG', label: 'Ogliastra' },
  { value: 'OT', label: 'Olbia Tempio' },
  { value: 'OR', label: 'Oristano' },
  { value: 'PD', label: 'Padova' },
  { value: 'PA', label: 'Palermo' },
  { value: 'PR', label: 'Parma' },
  { value: 'PV', label: 'Pavia' },
  { value: 'PG', label: 'Perugia' },
  { value: 'PU', label: 'Pesaro-Urbino' },
  { value: 'PE', label: 'Pescara' },
  { value: 'PC', label: 'Piacenza' },
  { value: 'PI', label: 'Pisa' },
  { value: 'PT', label: 'Pistoia' },
  { value: 'PN', label: 'Pordenone' },
  { value: 'PZ', label: 'Potenza' },
  { value: 'PO', label: 'Prato' },
  { value: 'RG', label: 'Ragusa' },
  { value: 'RA', label: 'Ravenna' },
  { value: 'RC', label: 'Reggio-Calabria' },
  { value: 'RE', label: 'Reggio-Emilia' },
  { value: 'RI', label: 'Rieti' },
  { value: 'RN', label: 'Rimini' },
  { value: 'RM', label: 'Roma' },
  { value: 'RO', label: 'Rovigo' },
  { value: 'SA', label: 'Salerno' },
  { value: 'SS', label: 'Sassari' },
  { value: 'SV', label: 'Savona' },
  { value: 'SI', label: 'Siena' },
  { value: 'SR', label: 'Siracusa' },
  { value: 'SO', label: 'Sondrio' },
  { value: 'TA', label: 'Taranto' },
  { value: 'TE', label: 'Teramo' },
  { value: 'TR', label: 'Terni' },
  { value: 'TO', label: 'Torino' },
  { value: 'TP', label: 'Trapani' },
  { value: 'TN', label: 'Trento' },
  { value: 'TV', label: 'Treviso' },
  { value: 'TS', label: 'Trieste' },
  { value: 'UD', label: 'Udine' },
  { value: 'VA', label: 'Varese' },
  { value: 'VE', label: 'Venezia' },
  { value: 'VB', label: 'Verbania' },
  { value: 'VC', label: 'Vercelli' },
  { value: 'VR', label: 'Verona' },
  { value: 'VV', label: 'Vibo-Valentia' },
  { value: 'VI', label: 'Vicenza' },
  { value: 'VT', label: 'Viterbo' },
];

export const enNations = [
  {
    value: 'ABW',
    label: 'Aruba',
  },
  {
    value: 'AFG',
    label: 'Afghanistan',
  },
  {
    value: 'AGO',
    label: 'Angola',
  },
  {
    value: 'AIA',
    label: 'Anguilla',
  },
  {
    value: 'ALB',
    label: 'Albania',
  },
  {
    value: 'AND',
    label: 'Andorra',
  },
  {
    value: 'ANT',
    label: 'Netherlands Antilles',
  },
  {
    value: 'ARE',
    label: 'United Arab Emirates',
  },
  {
    value: 'ARG',
    label: 'Argentina',
  },
  {
    value: 'ARM',
    label: 'Armenia',
  },
  {
    value: 'ASM',
    label: 'American Samoa',
  },
  {
    value: 'ATA',
    label: 'Antarctica',
  },
  {
    value: 'ATF',
    label: 'French Southern and Antarctic Lands',
  },
  {
    value: 'ATG',
    label: 'Antigua and Barbuda',
  },
  {
    value: 'AUS',
    label: 'Australia',
  },
  {
    value: 'AUT',
    label: 'Austria',
  },
  {
    value: 'AZE',
    label: 'Azerbaijan',
  },
  {
    value: 'BDI',
    label: 'Burundi',
  },
  {
    value: 'BEL',
    label: 'Belgium',
  },
  {
    value: 'BEN',
    label: 'Benin',
  },
  {
    value: 'BFA',
    label: 'Burkina Faso',
  },
  {
    value: 'BGD',
    label: 'Bangladesh',
  },
  {
    value: 'BGR',
    label: 'Bulgaria',
  },
  {
    value: 'BHR',
    label: 'Bahrain',
  },
  {
    value: 'BHS',
    label: 'Bahamas',
  },
  {
    value: 'BIH',
    label: 'Bosnia and Herzegovina',
  },
  {
    value: 'BLM',
    label: 'Saint Barthélemy',
  },
  {
    value: 'BLR',
    label: 'Belarus',
  },
  {
    value: 'BLZ',
    label: 'Belize',
  },
  {
    value: 'BMU',
    label: 'Bermuda',
  },
  {
    value: 'BOL',
    label: 'Bolivia',
  },
  {
    value: 'BRA',
    label: 'Brazil',
  },
  {
    value: 'BRB',
    label: 'Barbados',
  },
  {
    value: 'BRN',
    label: 'Brunei',
  },
  {
    value: 'BTN',
    label: 'Bhutan',
  },
  {
    value: 'BVT',
    label: 'Bouvet Island',
  },
  {
    value: 'BWA',
    label: 'Botswana',
  },
  {
    value: 'CAF',
    label: 'Central African Republic',
  },
  {
    value: 'CAN',
    label: 'Canada',
  },
  {
    value: 'CCK',
    label: 'Cocos Islands',
  },
  {
    value: 'CHE',
    label: 'Switzerland',
  },
  {
    value: 'CHL',
    label: 'Chile',
  },
  {
    value: 'CHN',
    label: 'China',
  },
  {
    value: 'CIV',
    label: 'Ivory Coast',
  },
  {
    value: 'CMR',
    label: 'Cameroon',
  },
  {
    value: 'COD',
    label: 'Democratic Republic of Congo',
  },
  {
    value: 'COG',
    label: 'Republic of the Congo',
  },
  {
    value: 'COK',
    label: 'Cook Islands',
  },
  {
    value: 'COL',
    label: 'Colombia',
  },
  {
    value: 'COM',
    label: 'Comoros',
  },
  {
    value: 'CPV',
    label: 'Cape Verde',
  },
  {
    value: 'CRI',
    label: 'Costa Rica',
  },
  {
    value: 'CUB',
    label: 'Cuba',
  },
  {
    value: 'CXR',
    label: 'Christmas Island',
  },
  {
    value: 'CYM',
    label: 'Cayman Islands',
  },
  {
    value: 'CYP',
    label: 'Cyprus',
  },
  {
    value: 'CZE',
    label: 'Czech Republic',
  },
  {
    value: 'DEU',
    label: 'Germany',
  },
  {
    value: 'DJI',
    label: 'Djibouti',
  },
  {
    value: 'DMA',
    label: 'Dominica',
  },
  {
    value: 'DNK',
    label: 'Denmark',
  },
  {
    value: 'DOM',
    label: 'Dominican Republic',
  },
  {
    value: 'DZA',
    label: 'Algeria',
  },
  {
    value: 'ECU',
    label: 'Ecuador',
  },
  {
    value: 'EGY',
    label: 'Egypt',
  },
  {
    value: 'ERI',
    label: 'Eritrea',
  },
  {
    value: 'ESH',
    label: 'Western Sahara',
  },
  {
    value: 'ESP',
    label: 'Spain',
  },
  {
    value: 'EST',
    label: 'Estonia',
  },
  {
    value: 'ETH',
    label: 'Ethiopia',
  },
  {
    value: 'FIN',
    label: 'Finland',
  },
  {
    value: 'FJI',
    label: 'Fiji',
  },
  {
    value: 'FLK',
    label: 'Falkland Islands',
  },
  {
    value: 'FRA',
    label: 'France',
  },
  {
    value: 'FRO',
    label: 'Faroe Islands',
  },
  {
    value: 'FSM',
    label: 'Federated States of Micronesia',
  },
  {
    value: 'GAB',
    label: 'Gabon',
  },
  {
    value: 'GBR',
    label: 'United Kingdom',
  },
  {
    value: 'GEO',
    label: 'Georgia',
  },
  {
    value: 'GGY',
    label: 'Guernsey',
  },
  {
    value: 'GHA',
    label: 'Ghana',
  },
  {
    value: 'GIB',
    label: 'Gibraltar',
  },
  {
    value: 'GIN',
    label: 'Guinea',
  },
  {
    value: 'GLP',
    label: 'Guadeloupe',
  },
  {
    value: 'GMB',
    label: 'Gambia',
  },
  {
    value: 'GNB',
    label: 'Guinea-Bissau',
  },
  {
    value: 'GNQ',
    label: 'Equatorial Guinea',
  },
  {
    value: 'GRC',
    label: 'Greece',
  },
  {
    value: 'GRD',
    label: 'Grenada',
  },
  {
    value: 'GRL',
    label: 'Greenland',
  },
  {
    value: 'GTM',
    label: 'Guatemala',
  },
  {
    value: 'GUF',
    label: 'French Guiana',
  },
  {
    value: 'GUM',
    label: 'Guam',
  },
  {
    value: 'GUY',
    label: 'Guyana',
  },
  {
    value: 'HKG',
    label: 'Hong Kong',
  },
  {
    value: 'HMD',
    label: 'Heard Island and McDonald Islands',
  },
  {
    value: 'HND',
    label: 'Honduras',
  },
  {
    value: 'HRV',
    label: 'Croatia',
  },
  {
    value: 'HTI',
    label: 'Haiti',
  },
  {
    value: 'HUN',
    label: 'Hungary',
  },
  {
    value: 'IDN',
    label: 'Indonesia',
  },
  {
    value: 'IND',
    label: 'India',
  },
  {
    value: 'IOT',
    label: 'British Indian Ocean Territories',
  },
  {
    value: 'IRL',
    label: 'Eire',
  },
  {
    value: 'IRN',
    label: 'Iran',
  },
  {
    value: 'IRQ',
    label: 'Iraq',
  },
  {
    value: 'ISL',
    label: 'Iceland',
  },
  {
    value: 'ISR',
    label: 'Israel',
  },
  {
    value: 'ITA',
    label: 'Italy',
  },
  {
    value: 'JAM',
    label: 'Jamaica',
  },
  {
    value: 'JOR',
    label: 'Jordan',
  },
  {
    value: 'JPN',
    label: 'Japan',
  },
  {
    value: 'KAZ',
    label: 'Kazakhstan',
  },
  {
    value: 'KEN',
    label: 'Kenya',
  },
  {
    value: 'KGZ',
    label: 'Kyrgyzstan',
  },
  {
    value: 'KHM',
    label: 'Cambodia',
  },
  {
    value: 'KIR',
    label: 'Kiribati',
  },
  {
    value: 'KNA',
    label: 'Saint Kitts and Nevis',
  },
  {
    value: 'KOR',
    label: 'South Korea',
  },
  {
    value: 'KWT',
    label: 'Kuwait',
  },
  {
    value: 'LAO',
    label: 'Laos',
  },
  {
    value: 'LBN',
    label: 'Lebanon',
  },
  {
    value: 'LBR',
    label: 'Liberia',
  },
  {
    value: 'LBY',
    label: 'Lybia',
  },
  {
    value: 'LCA',
    label: 'Saint Lucia',
  },
  {
    value: 'LIE',
    label: 'Liechtenstein',
  },
  {
    value: 'LKA',
    label: 'Sri Lanka',
  },
  {
    value: 'LSO',
    label: 'Lesotho',
  },
  {
    value: 'LTU',
    label: 'Lithuania',
  },
  {
    value: 'LUX',
    label: 'Luxembourg',
  },
  {
    value: 'LVA',
    label: 'Latvia',
  },
  {
    value: 'MAC',
    label: 'Macao',
  },
  {
    value: 'MAR',
    label: 'Morocco',
  },
  {
    value: 'MCO',
    label: 'Monaco',
  },
  {
    value: 'MDA',
    label: 'Moldova',
  },
  {
    value: 'MDG',
    label: 'Madagascar',
  },
  {
    value: 'MDV',
    label: 'Maldives',
  },
  {
    value: 'MEX',
    label: 'Mexico',
  },
  {
    value: 'MHL',
    label: 'Marshall Islands',
  },
  {
    value: 'MKD',
    label: 'Macedonia',
  },
  {
    value: 'MLI',
    label: 'Mali',
  },
  {
    value: 'MLT',
    label: 'Malta',
  },
  {
    value: 'MMR',
    label: 'Myanmar',
  },
  {
    value: 'MNE',
    label: 'Montenegro',
  },
  {
    value: 'MNG',
    label: 'Mongolia',
  },
  {
    value: 'MNP',
    label: 'Northern Mariana Islands',
  },
  {
    value: 'MOZ',
    label: 'Mozambique',
  },
  {
    value: 'MRT',
    label: 'Mauritania',
  },
  {
    value: 'MSR',
    label: 'Montserrat',
  },
  {
    value: 'MTQ',
    label: 'Martinique',
  },
  {
    value: 'MUS',
    label: 'Mauritius',
  },
  {
    value: 'MWI',
    label: 'Malawi',
  },
  {
    value: 'MYS',
    label: 'Malaysia',
  },
  {
    value: 'MYT',
    label: 'Mayotte',
  },
  {
    value: 'NAM',
    label: 'Namibia',
  },
  {
    value: 'NCL',
    label: 'New Caledonia',
  },
  {
    value: 'NER',
    label: 'Niger',
  },
  {
    value: 'NFK',
    label: 'Norfolk Island',
  },
  {
    value: 'NGA',
    label: 'Nigeria',
  },
  {
    value: 'NIC',
    label: 'Nicaragua',
  },
  {
    value: 'NIU',
    label: 'Niue',
  },
  {
    value: 'NLD',
    label: 'Netherlands',
  },
  {
    value: 'NOR',
    label: 'Norway',
  },
  {
    value: 'NPL',
    label: 'Nepal',
  },
  {
    value: 'NRU',
    label: 'Nauru',
  },
  {
    value: 'NZL',
    label: 'New Zealand',
  },
  {
    value: 'OMN',
    label: 'Oman',
  },
  {
    value: 'PAK',
    label: 'Pakistan',
  },
  {
    value: 'PAN',
    label: 'Panama',
  },
  {
    value: 'PCN',
    label: 'Pitcairn Islands',
  },
  {
    value: 'PER',
    label: 'Peru',
  },
  {
    value: 'PHL',
    label: 'Philippines',
  },
  {
    value: 'PLW',
    label: 'Palau',
  },
  {
    value: 'PNG',
    label: 'Papua New Guinea',
  },
  {
    value: 'POL',
    label: 'Poland',
  },
  {
    value: 'PRI',
    label: 'Puerto Rico',
  },
  {
    value: 'PRK',
    label: 'North Korea',
  },
  {
    value: 'PRT',
    label: 'Portugal',
  },
  {
    value: 'PRY',
    label: 'Paraguay',
  },
  {
    value: 'PSE',
    label: 'Occupied Palestinian Territories',
  },
  {
    value: 'PYF',
    label: 'French Polynesia',
  },
  {
    value: 'QAT',
    label: 'Qatar',
  },
  {
    value: 'REU',
    label: 'Reunion',
  },
  {
    value: 'ROU',
    label: 'Romania',
  },
  {
    value: 'RUS',
    label: 'Russian Federation',
  },
  {
    value: 'RWA',
    label: 'Rwanda',
  },
  {
    value: 'SAU',
    label: 'Saudi Arabia',
  },
  {
    value: 'SDN',
    label: 'Sudan',
  },
  {
    value: 'SEN',
    label: 'Senegal',
  },
  {
    value: 'SGP',
    label: 'Singapore',
  },
  {
    value: 'SGS',
    label: 'South Georgia and The Sandwich Islands',
  },
  {
    value: 'SHN',
    label: 'Saint Helena',
  },
  {
    value: 'SJM',
    label: 'Svalbard e Jan Mayen',
  },
  {
    value: 'SLB',
    label: 'Solomon Islands',
  },
  {
    value: 'SLE',
    label: 'Sierra Leone',
  },
  {
    value: 'SLV',
    label: 'El Salvador',
  },
  {
    value: 'SMR',
    label: 'San Marino',
  },
  {
    value: 'SOM',
    label: 'Somalia',
  },
  {
    value: 'SPM',
    label: 'Saint Pierre and Miquelon',
  },
  {
    value: 'SRB',
    label: 'Serbia',
  },
  {
    value: 'STP',
    label: 'Saint Thomas and Prince',
  },
  {
    value: 'SUR',
    label: 'Suriname',
  },
  {
    value: 'SVK',
    label: 'Slovakia',
  },
  {
    value: 'SVN',
    label: 'Slovenia',
  },
  {
    value: 'SWE',
    label: 'Sweden',
  },
  {
    value: 'SWZ',
    label: 'Swaziland',
  },
  {
    value: 'SYC',
    label: 'Seychelles',
  },
  {
    value: 'SYR',
    label: 'Syria',
  },
  {
    value: 'TCA',
    label: 'Turks and Caicos Islands',
  },
  {
    value: 'TCD',
    label: 'Chad',
  },
  {
    value: 'TGO',
    label: 'Togo',
  },
  {
    value: 'THA',
    label: 'Thailand',
  },
  {
    value: 'TJK',
    label: 'Tajikistan',
  },
  {
    value: 'TKL',
    label: 'Tokelau',
  },
  {
    value: 'TKM',
    label: 'Turkmenistan',
  },
  {
    value: 'TLS',
    label: 'East Timor',
  },
  {
    value: 'TON',
    label: 'Tonga',
  },
  {
    value: 'TTO',
    label: 'Trinidad and Tobago',
  },
  {
    value: 'TUN',
    label: 'Tunisia',
  },
  {
    value: 'TUR',
    label: 'Turkey',
  },
  {
    value: 'TUV',
    label: 'Tuvalu',
  },
  {
    value: 'TWN',
    label: 'Taiwan',
  },
  {
    value: 'TZA',
    label: 'Tanzania',
  },
  {
    value: 'UGA',
    label: 'Uganda',
  },
  {
    value: 'UKR',
    label: 'Ukraine',
  },
  {
    value: 'UMI',
    label: 'United States Minor Outlying Islands',
  },
  {
    value: 'URY',
    label: 'Uruguay',
  },
  {
    value: 'USA',
    label: 'United States of America',
  },
  {
    value: 'UZB',
    label: 'Uzbekistan',
  },
  {
    value: 'VAT',
    label: 'Vatican City',
  },
  {
    value: 'VCT',
    label: 'Saint Vincent and the Grenadines',
  },
  {
    value: 'VEN',
    label: 'Venezuela',
  },
  {
    value: 'VGB',
    label: 'British Virgin Islands',
  },
  {
    value: 'VIR',
    label: 'Virgin Islands of the United States',
  },
  {
    value: 'VNM',
    label: 'Vietnam',
  },
  {
    value: 'VUT',
    label: 'Vanuatu',
  },
  {
    value: 'WLF',
    label: 'Wallis and Futuna',
  },
  {
    value: 'WSM',
    label: 'Samoa',
  },
  {
    value: 'XKX',
    label: 'Kosovo',
  },
  {
    value: 'YEM',
    label: 'Yemen',
  },
  {
    value: 'ZAF',
    label: 'South Africa',
  },
  {
    value: 'ZMB',
    label: 'Zambia',
  },
  {
    value: 'ZWE',
    label: 'Zimbabwe',
  },
];

export const getRoleOptions = (i18n) => ({
  adp: [
    { label: i18n.owner, value: 1007 },
    { label: i18n.senior, value: 1008 },
    { label: i18n.junior, value: 1009 },
    { label: i18n.projectManager, value: 1010 },
    { label: i18n.other, value: 1011 },
  ],
  apa: [
    { label: i18n.owner, value: 1012 },
    { label: i18n.purchasingDepartment, value: 1013 },
    { label: i18n.projectManager, value: 1014 },
    { label: i18n.other, value: 1015 },
  ],
  ret: [
    { label: i18n.ceo, value: 1016 },
    { label: i18n.storeManager, value: 1017 },
    { label: i18n.retailOperations, value: 1018 },
    { label: i18n.buyer, value: 1019 },
    { label: i18n.sales, value: 1020 },
    { label: i18n.architect, value: 1021 },
    { label: i18n.assembler, value: 1022 },
    { label: i18n.other, value: 1023 },
  ],
  grs: [
    { label: i18n.owner, value: 1024 },
    { label: i18n.purchasingDepartment, value: 1025 },
    { label: i18n.salesDepartment, value: 1026 },
    { label: i18n.marketingDepartment, value: 1027 },
    { label: i18n.other, value: 1028 },
  ],
  frn: [
    { label: i18n.owner, value: 1029 },
    { label: i18n.divisionManager, value: 1030 },
    { label: i18n.salesDepartmentFrn, value: 1031 },
    { label: i18n.purchasingDepartment, value: 1032 },
    { label: i18n.other, value: 1033 },
  ],
  agn: [
    { label: i18n.owner, value: 1034 },
    { label: i18n.employeeSenior, value: 1035 },
    { label: i18n.employeeJunior, value: 1036 },
    { label: i18n.employeeProjectManager, value: 1037 },
    { label: i18n.other, value: 1038 },
  ],
  prd: [
    { label: i18n.businessOwner, value: 1001 },
    { label: i18n.director, value: 1002 },
    { label: i18n.manager, value: 1003 },
    { label: i18n.artisan, value: 1004 },
    { label: i18n.other, value: 1006 },
  ],
});

export const rolesInCompanyOthersValues = [
  1011, 1015, 1023, 1028, 1033, 1038, 1006,
];
